<template>
  <div>
    <v-row :justify="$vuetify.breakpoint.xs ? 'center' : 'end'">
      <v-col cols="auto">
        <button-cadu @click="showHistorico = true">
          Histórico
        </button-cadu>
      </v-col>
      <v-col cols="auto" class="mt-2" @click="anexar" v-if="opcaoEditar">
        <icon name="paperclip" :size="20" style="cursor: pointer;" tooltip="Anexar Documento" />
      </v-col>
    </v-row>
    <v-row v-if="isLoadingSelo">
      <v-col cols="12" sm="10" md="12">
        <component-loading :value="isLoadingSelo" />
      </v-col>
    </v-row>
    <v-row v-else-if="listaSeloCertificacao.length > 0">
      <v-col cols="12" sm="12" md="12">
        <div class="certificacoes-lista px-2 mt-2">
          <v-row class="px-2 py-2">
            <v-col cols="auto" v-for="(item, index) in listaSeloCertificacao" :key="index">
              <card-cadu
                :disabledButtons="permissaoBotoes(item.tipoSelo)"
                :seloCertificacao="item"
                :canEdit="canEdit"
                @clickButton="(obj) => getAction(obj)"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" sm="12" md="12">
        <div class="certificacoes-sem-lista px-2 mt-2">
          <div class="child">Não existe nenhum registro.</div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="!isLoadingSelo">
      <v-col cols="auto">
        <a @click="getAction({ type: 'add' })" style="color: #1492e6;" v-if="canEdit">
          + adicionar nova certificação/selo
        </a>
      </v-col>
    </v-row>

    <ExcluirModal
      :text="'Tem certeza que deseja excluir essa certificação/selo?'"
      :showDelete="showDelete"
      @close="showDelete = false"
      @confirmDelete="deletarCertificacaoSelo(selected)"
    />

    <SucessoModal
      :genericMessage="messageANS"
      :showSucess="showSucess"
      :sucessType="typeSucess"
      @close="closeSucesso"
    />

    <ModalCertificacao
      ref="modalCertificacao"
      v-model="showModal"
      :seloCertificado="seloCertificadoSelecionado"
      :action="action"
      @save-certificacao-selo="(obj) => atualizarCertificacaoSelo(obj, false)"
      @save-certificacao-criarOutro="(obj) => atualizarCertificacaoSelo(obj, true)"
      @listar-ativos="getCertificacaoSelo()"
    />

    <overlay-loading v-model="loadingOverlay" />

    <error-modal v-model="showError" :errObj="errObj" />

    <ModalHistorico v-model="showHistorico" :listaSelosBloqueados="listaSelosBloqueados" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

import Selo from '../../../../../services/Selos/Selo'
import ModalCertificacao from './ModalCertificacao'
import ModalHistorico from './ModalHistoricoCertificado'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  components: {
    ModalCertificacao,
    ModalHistorico
  },
  data() {
    return {
      listaSeloCertificacao: [],
      listaSelosBloqueados: [],
      selected: [],
      seloCertificadoSelecionado: {},
      showModal: false,
      showHistorico: false,
      action: '',
      role: '',
      isLoadingSelo: false,
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      criarOutro: false,

      // Sucesso Modal
      messageANS: '',
      showSucess: false,
      typeSucess: '',
      type: '',

      // Error Modal
      showError: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },

      loadingOverlay: false,
      showDelete: false,
      error: false
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role

    EventBus.$on('carregarCertificacoes', async (carregar) => {
      if (carregar) {
        this.isLoadingSelo = true
        this.getCertificacaoSelo()
        this.getListaSelosExcluirBloqueados()
        this.permissaoBotoes()
        EventBus.$emit('carregarCertificacoes', false)
      }
    })

    this.isLoadingSelo = true
    this.getCertificacaoSelo()
    this.getListaSelosExcluirBloqueados()
    this.permissaoBotoes()
  },
  methods: {
    anexar() {
      EventBus.$emit('showAnexo', 'Certificações')
    },
    getAction(obj) {
      this.type = obj.type

      switch (obj.type) {
        case 'add':
          this.seloCertificadoSelecionado = this.emptyObject()
          this.action = 'add'
          this.showModal = true
          break

        case 'edit':
          this.seloCertificadoSelecionado = obj.seloCertificacao
          this.action = 'edit'
          this.showModal = true
          break

        case 'view':
          this.seloCertificadoSelecionado = obj.seloCertificacao
          this.action = 'view'
          this.showModal = true
          break

        case 'delete':
          this.selected = [obj.seloCertificacao.id]
          this.showDelete = true
          break
      }
    },
    emptyObject() {
      return {
        dataFim: '',
        dataInicio: '',
        ano: '',
        id: null,
        instituicaoResponsavel: {
          ativo: false,
          id: null,
          nome: '',
          ordem: 0
        },
        tipoSelo: {
          arquivo: {
            container: '',
            nome: '',
            uuid: ''
          },
          ativo: false,
          descricao: '',
          id: null,
          nome: '',
          niveis: []
        }
      }
    },
    closeSucesso() {
      if (this.criarOutro) {
        this.seloCertificadoSelecionado = this.emptyObject()
        this.showSucess = false
        this.showModal = true
      } else {
        this.showSucess = false
      }
    },
    async getListaSelosExcluirBloqueados() {
      const selo = new Selo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await selo.getPermissaoExcluirSelo().then((res) => {
        this.listaSelosBloqueados = res.data
      })
    },
    permissaoBotoes(tipoSelo = null) {
      let disabledButtons = [false, false, false]

      if (this.verifyPermission() && this.isEditar()) {
        disabledButtons = [true, true, true]
      } else {
        disabledButtons = [true, false, false]
      }

      if (tipoSelo != null && this.listaSelosBloqueados.includes(tipoSelo.nome)) {
        disabledButtons = [true, false, false]
      }

      if (this.role !== 'admin_brasil' && !!tipoSelo && tipoSelo.bloqueado) disabledButtons = [true, false, false]

      return disabledButtons
    },
    verifyPermission() {
      if (this.role === 'admin_brasil' || this.role === 'admin' || this.role === 'dirigente') {
        return true
      } else {
        return false
      }
    },
    isEditar() {
      return this.opcaoEditar === true
    },

    async getCertificacaoSelo() {
      this.isLoadingSelo = true
      const selo = new Selo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await selo
        .getSelosAtivos()
        .then((res) => (this.listaSeloCertificacao = res.data))
        .catch((err) => {
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
          this.showError = true
        })
        .finally(() => (this.isLoadingSelo = false))
    },
    async atualizarCertificacaoSelo(obj, criarOutro) {
      this.showModal = false
      this.loadingOverlay = true
      const selo = new Selo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await selo
        .putSelo(obj)
        .then(() => {
          if (this.type === 'add') {
            this.messageANS = 'Certificado/Selo Adicionado com sucesso!'
          } else if (this.type === 'edit') {
            this.messageANS = 'Certificado/Selo editado com sucesso!'
          }

          this.loadingOverlay = false
          this.showSucess = true

          this.criarOutro = criarOutro
        })
        .catch((err) => {
          console.error(err)
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message

          this.loadingOverlay = false
          this.showError = true
        })
        .finally(() => {
          this.getCertificacaoSelo()
        })
    },
    async deletarCertificacaoSelo(obj) {
      this.loadingOverlay = true
      this.showDelete = false

      const selo = new Selo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await selo
        .delSelos(obj)
        .then((res) => {
          this.messageANS = 'Certificação/Selo excluído com sucesso!'

          this.loadingOverlay = false
          this.showSucess = true
        })
        .catch((err) => {
          console.error(err)
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message

          this.loadingOverlay = false
          this.showError = true
        })
        .finally(() => {
          this.getCertificacaoSelo()
        })
    }
  },
  computed: {
    canEdit() {
      if (
        this.opcaoEditar === true &&
        (this.role === 'admin_brasil' || this.role === 'dirigente' || this.role === 'admin')
      ) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.certificacoes-lista {
  overflow-x: hidden;
  overflow-y: scroll;

  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;

  width: 100%;
  height: 460px;
}

.certificacoes-sem-lista {
  overflow-x: hidden;
  overflow-y: hidden;

  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;

  text-align: center;
  font-size: 20px;
  display: table;

  width: 100%;
  height: 300px;
}

.child {
  display: table-cell;
  vertical-align: middle;
  padding-left: 20px;
}
</style>
